/**
 * MungPay Repository Interface
 *
 * 제공하는 API:
 * 1. POST /mungpay/claims - 보험 청구 생성
 * 2. POST /mungpay/claims/{id}/phone-verify - 전화번호 인증
 * 3. GET /mungpay/claims/number/{claimNumber}/status - 청구 상태 조회
 * 4. GET /mungpay/claims/{id}/result - 청구 결과 조회
 * 5. GET /s3/mungpay/presigned-url + PUT to S3 - S3 파일 업로드
 * 6. POST /mungpay/kb_receipt_analyze - KB 영수증 분석
 */
export class IMungPayRepository {
  /**
   * 보험 청구 생성
   * @param {Object} url - 청구 데이터 (medical_receipt_url 포함)
   * @returns {Promise<BaseResponse<any>>}
   */
  async createClaim(url) {
    throw new Error('Method must be implemented');
  }

  /**
   * 전화번호 인증
   * @param {string} claimId - 청구 ID
   * @param {Object} phoneNumber - 전화번호 데이터 (phone_number 포함)
   * @returns {Promise<BaseResponse<any>>}
   */
  async verifyPhone(claimId, phoneNumber) {
    throw new Error('Method must be implemented');
  }

  /**
   * 청구 상태 조회
   * @param {string} claimNumber - 청구 번호 (예: MP2025080163EC1C)
   * @returns {Promise<BaseResponse<any>>}
   */
  async getClaimStatus(claimNumber) {
    throw new Error('Method must be implemented');
  }

  /**
   * 청구 결과 조회
   * @param {number} claimId - 청구 ID (예: 85)
   * @returns {Promise<BaseResponse<any>>}
   */
  async getClaimResult(claimId) {
    throw new Error('Method must be implemented');
  }

  /**
   * S3 파일 업로드 (Presigned URL 방식)
   * @param {File} file - 업로드할 파일 객체
   * @param {string} expiration - URL 만료 시간 (분 단위, 기본값: '60')
   * @returns {Promise<Object>} 업로드 결과 객체
   */
  async uploadToS3(file, expiration = '60') {
    throw new Error('Method must be implemented');
  }

  /**
   * KB 영수증 분석
   * @param {string} medicalReceiptUrl - 의료 영수증 이미지 URL
   * @returns {Promise<BaseResponse<any>>}
   */
  async analyzeKbReceipt(medicalReceiptUrl) {
    throw new Error('Method must be implemented');
  }
}
